module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tag-list"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [(_vm.options && _vm.options.top_border) ? _c('hr') : _vm._e(), _vm._l((_vm.tags), function(tag) {
    return _c('list-item', {
      key: tag.id,
      attrs: {
        "tag": tag,
        "options": _vm.list_item_options
      },
      on: {
        "updated": _vm.tagUpdated,
        "destroy": _vm.openDestroyConfirmationModal,
        "selection-toggle": _vm.tagSelectionToggle
      }
    })
  })], 2)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && !_vm.tags.length),
      expression: "!loading && !tags.length"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1), (_vm.list_item_options.can_edit) ? _c('confirm-modal', {
    attrs: {
      "id": "confirm-destroy-tag",
      "title": "Excluir categoria",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.destroyTag
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Confirma exclusão da tag abaixo?")]), _c('br'), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.selected_tag.name))]), _c('br'), _c('br')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6589c6f8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tags/list.vue
// module id = 1156
// module chunks = 1